// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1Ekrk","footer":"ChangeClinic_footer__3TyMP"};